import { operatorApiFetch } from './apiService';

export const orderService = {
  // 列表 (GET) - 用於搜尋
  fetchList: async (params = {}) => {
    // 簡單地將所有 params 轉為 query string
    // operatorApiFetch 內部會處理 params
    const response = await operatorApiFetch('orders', {
      method: 'GET',
      params: params
    });
    return response.json();
  },

  // 列表 (POST) - 用於 TableIndex
  getRecords: async (params) => {
    const response = await operatorApiFetch('orders/get_records', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },

  // 全選 ID
  getIds: async (params) => {
    const response = await operatorApiFetch('orders/get_ids', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },

  // 獲取單個訂單
  get: async (id) => {
    const response = await operatorApiFetch(`orders/${id}`, {
      method: 'GET'
    });
    return response.json();
  },

  // 建議訂單單號
  suggestName: async (merchantId = null) => {
    const response = await operatorApiFetch('orders/suggest_name', {
      method: 'GET',
      params: merchantId ? { merchant_id: merchantId } : {}
    });
    return response.json();
  },

  // 檢查庫存
  batchCheck: async (ids) => {
    const response = await operatorApiFetch('orders/batch_check', {
      method: 'POST',
      body: JSON.stringify({ ids })
    });
    return response.json();
  },

  // 恢復訂單
  batchResume: async (ids) => {
    const response = await operatorApiFetch('orders/batch_resume', {
      method: 'POST',
      body: JSON.stringify({ ids })
    });
    return response.json();
  },

  // 取消訂單
  batchCancel: async (ids) => {
    const response = await operatorApiFetch('orders/batch_cancel', {
      method: 'POST',
      body: JSON.stringify({ ids })
    });
    return response.json();
  },

  // 批次攔截訂單
  batchHold: async (ids, reason, note) => {
    const response = await operatorApiFetch('orders/batch_hold', {
      method: 'POST',
      body: JSON.stringify({ ids, reason, note })
    });
    return response.json();
  },

  // 匯出
  export: async (ids, params = {}) => {
    const response = await operatorApiFetch('orders/export', {
      method: 'POST',
      body: { ids, ...params }
    });
    return response.json();
  },

  // 下載 PDF
  downloadPdf: async (ids) => {
    const response = await operatorApiFetch('orders/download_pdf', {
      method: 'POST',
      body: JSON.stringify({ ids })
    });
    return response.json();
  },

  // 建立退貨單
  batchCreateReturnOrder: async (ids) => {
    const response = await operatorApiFetch('orders/batch_create_return_order', {
      method: 'POST',
      body: JSON.stringify({ ids })
    });
    return response.json();
  },

  // 草稿轉正式
  batchDraftOrderConvert: async (ids) => {
    const response = await operatorApiFetch('orders/batch_draft_order_convert', {
      method: 'POST',
      body: JSON.stringify({ ids })
    });
    return response.json();
  },

  // 正式轉草稿
  batchConvertToDraftOrder: async (ids, params = {}) => {
    const response = await operatorApiFetch('orders/batch_convert_to_draft_order', {
      method: 'POST',
      body: JSON.stringify({ ids, ...params })
    });
    return response.json();
  },

  // 正式轉急件
  batchConvertToUrgentOrder: async (ids) => {
    const response = await operatorApiFetch('orders/batch_convert_to_urgent_order', {
      method: 'POST',
      body: JSON.stringify({ ids })
    });
    return response.json();
  },

  // 急件轉正式
  batchUrgentOrderConvert: async (ids) => {
    const response = await operatorApiFetch('orders/batch_urgent_order_convert', {
      method: 'POST',
      body: JSON.stringify({ ids })
    });
    return response.json();
  },

  // 批量更新 (Edit Modal)
  batchUpdate: async (ids, actions) => {
    const response = await operatorApiFetch('orders/batch_update', {
      method: 'POST',
      body: JSON.stringify({ ids, actions })
    });
    return response.json();
  },

  // 批次拆分 fulfillment
  batchSplitFulfillments: async (ids, params) => {
    const response = await operatorApiFetch('orders/batch_split_fulfillments', {
      method: 'POST',
      body: JSON.stringify({ ids, ...params })
    });
    return response.json();
  },

  // 移除訂單商品
  batchRemoveOrderProducts: async (ids, params) => {
    const response = await operatorApiFetch('orders/batch_remove_order_products', {
      method: 'POST',
      body: JSON.stringify({ ids, ...params })
    });
    return response.json();
  },

  // 取消單個訂單
  cancel: async (id) => {
    const response = await operatorApiFetch(`orders/${id}/cancel`, {
      method: 'POST',
    });
    return response.json();
  },

  // 恢復單個訂單
  resume: async (id) => {
    const response = await operatorApiFetch(`orders/${id}/resume`, {
      method: 'POST',
    });
    return response.json();
  },

  // 重新檢查庫存
  recheckStock: async (id) => {
    const response = await operatorApiFetch(`orders/${id}/recheck_stock`, {
      method: 'POST',
    });
    return response.json();
  },

  // 延遲單個訂單
  postpone: async (id) => {
    const response = await operatorApiFetch(`orders/${id}/postpone`, {
      method: 'POST',
    });
    return response.json();
  },

  // 轉換為正常訂單
  convertToNormal: async (id) => {
    const response = await operatorApiFetch(`orders/${id}/finalize_draft`, {
      method: 'POST',
    });
    return response.json();
  },

  // 釋放攔截
  releaseHolds: async (id, resolutionNote) => {
    const response = await operatorApiFetch(`orders/${id}/release_holds`, {
      method: 'POST',
      body: JSON.stringify({ resolution_note: resolutionNote })
    });
    return response.json();
  },

  // 攔截訂單
  hold: async (id, params = {}) => {
    const response = await operatorApiFetch(`orders/${id}/hold`, {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },

  // 生成 PDF
  generatePdf: async (id) => {
    const response = await operatorApiFetch(`orders/${id}/generate_pdf`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        template_id: null
      }),
    });
    return response.json();
  },

  getVideos: async (orderId) => {
    const response = await operatorApiFetch(`orders/${orderId}/videos`, {
      method: "GET"
    });
    return response.json();
  },

  // 取得錄影 session 診斷資訊（含 GCS chunk 數量）— 救援工具用
  getRecordingSessions: async (orderId) => {
    const response = await operatorApiFetch(`orders/${orderId}/recording_sessions`, {
      method: "GET"
    });
    return response.json();
  },

  // 強制合併卡住的 RecordingSession（force=true，GCS prefix 掃描，跳過缺號 chunk）
  forceFinalizeRecordingSession: async (sessionId) => {
    const response = await operatorApiFetch(`recording_sessions/${sessionId}/force_finalize`, {
      method: "POST"
    });
    return response.json();
  },

  // 串接紀錄 tab — 列表（3 來源合併、metadata only）
  getIntegrationLogs: async (id) => {
    const response = await operatorApiFetch(`orders/${id}/integration_logs`, {
      method: 'GET'
    });
    return response.json();
  },

  // 串接紀錄 tab — 點開某筆 row 取切片（third_party 走 pointer，partner / webhook 整筆 payload）
  getIntegrationLogSlice: async (id, source, logId) => {
    const response = await operatorApiFetch(
      `orders/${id}/integration_logs/${source}/${logId}`,
      { method: 'GET' }
    );
    return response.json();
  },

  // 檢查訂單名稱可用性
  checkOrderNameAvailability: async (orderName) => {
    try {
      const response = await operatorApiFetch(`orders/0?name=${encodeURIComponent(orderName.trim())}`, {
        method: "GET"
      });

      if (response.ok) {
        const data = await response.json();
        if (data.success && data.data && data.data.id) {
          return { "exists": true, "orderId": data.data.id, "error": null };
        } else {
          return { "exists": false, "orderId": null, "error": new Error("Unexpected success response for non-existent order.") };
        }
      } else {
        if (response.status === 404) {
          return { "exists": false, "orderId": null, "error": null };
        } else {
          let errorMessage = `HTTP ${response.status}: ${response.statusText}`;
          try {
            const errorData = await response.json();
            errorMessage = errorData.message || errorMessage;
          } catch (e) {
            // response was not JSON
          }
          return { "exists": false, "orderId": null, "error": new Error(errorMessage) };
        }
      }
    } catch (err) {
      return { "exists": false, "orderId": null, "error": err };
    }
  },

  // 創建訂單
  createOrder: async (payload) => {
    const response = await operatorApiFetch('orders', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    return response.json();
  },

  // 序號列表
  getSerialNumbers: async (params) => {
    const response = await operatorApiFetch('orders/serial_numbers/get_records', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },

  // 驗證出貨單名稱是否存在
  validateFulfillmentNames: async (fulfillmentNames) => {
    const response = await operatorApiFetch('orders/validate_fulfillment_names', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ fulfillment_names: fulfillmentNames })
    });
    return response.json();
  },

  // 上傳物流標籤（以 Fulfillment 為主體）
  uploadLabel: async (formData) => {
    const response = await operatorApiFetch('orders/upload_label', {
      method: 'POST',
      body: formData
    });
    return response.json();
  },

  // 更新訂單
  update: async (id, payload) => {
    const response = await operatorApiFetch(`orders/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    return response.json();
  },

  // 修正訂單資訊（僅限地址、電話等欄位，不觸發重新分配）
  correct: async (id, payload) => {
    const response = await operatorApiFetch(`orders/${id}/correct`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    return response.json();
  },

  // 匯入訂單
  import: async (formData) => {
    const response = await operatorApiFetch('orders/import', {
      method: 'POST',
      body: formData
    });
    return response.json();
  },

  // 下載匯入模板
  downloadImportTemplate: (locale, merchantId) => {
    const body = { type: 'order', locale };
    if (merchantId) {
      body.merchant_id = merchantId;
    }
    return operatorApiFetch('import_templates/download', {
      method: 'POST',
      body: JSON.stringify(body),
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
    });
  },

  // ===== Value Added Services =====

  // 新增訂單加值服務
  addValueAddedService: async (orderId, data) => {
    const response = await operatorApiFetch(`orders/${orderId}/value_added_services`, {
      method: 'POST',
      body: JSON.stringify({ value_added_service: data })
    });
    return response.json();
  },

  // 更新訂單加值服務
  updateValueAddedService: async (orderId, serviceId, data) => {
    const response = await operatorApiFetch(`orders/${orderId}/value_added_services/${serviceId}`, {
      method: 'PATCH',
      body: JSON.stringify({ value_added_service: data })
    });
    return response.json();
  },

  // 刪除訂單加值服務
  deleteValueAddedService: async (orderId, serviceId) => {
    const response = await operatorApiFetch(`orders/${orderId}/value_added_services/${serviceId}`, {
      method: 'DELETE'
    });
    return response.json();
  },

  // 複製訂單
  duplicate: async (id, name) => {
    const body = name ? { name } : {}
    const response = await operatorApiFetch(`orders/${id}/duplicate`, {
      method: 'POST',
      body: JSON.stringify(body),
    });
    return response.json();
  },

  // ===== 附件 =====

  // 上傳訂單附件（FormData，沿用 purchaseOrderService 慣例）
  createAttachment: async (orderId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await operatorApiFetch(`orders/${orderId}/order_attachments`, {
      method: 'POST',
      body: formData
    });
    return response.json();
  },

  // 刪除訂單附件（僅手動上傳的附件可刪；匯入批次附件唯讀）
  deleteAttachment: async (orderId, attachmentId) => {
    const response = await operatorApiFetch(`orders/${orderId}/order_attachments/${attachmentId}`, {
      method: 'DELETE'
    });
    return response.json();
  }
};
export default orderService;
